// services/paymentApi.js

import axios from "axios";
import { makeRequest } from "../utils/handleJWT";

const PAYMENT_API_URL = "https://umlang.com/packages/api/v1";

/**
 * دریافت اطلاعات کاربر (برای presenterCode)
 */
export const getUserInfoApi = async () => {
  return makeRequest(async () => {
    const token = localStorage.getItem("token");
    const url = "https://auth.umlang.com/auth/api/v1/auth/register/userinfo";

    const response = await axios.post(url, {}, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return response.data;
  });
};

/**
 * بررسی اعتبار کد تخفیف
 */
export const checkDiscountCodeApi = async (marketingCode, productId) => {
  return makeRequest(async () => {
    const token = localStorage.getItem("token");
    const url = "https://umlang.com/marketing/api/v1/marketing/referral/codes/checkCodeForUse";

    const response = await axios.post(url, {
      marketingCode,
      productId
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return response.data;
  });
};

/**
 * ایجاد سفارش
 */
export const createOrderApi = async (data) => {
  return makeRequest(async () => {
    const token = localStorage.getItem("token");
    const url = `${PAYMENT_API_URL}/packages/buypackage`;

    const response = await axios.post(url, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return response.data;
  });
};

/**
 * درخواست پرداخت ملت
 */
export const requestMellatPaymentApi = async (data) => {
  return makeRequest(async () => {
    const token = localStorage.getItem("token");
    const url = `${PAYMENT_API_URL}/payment/mellatPay`;

    const response = await axios.post(url, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return response.data;
  });
};

/**
 * تایید پرداخت
 */
export const verifyPaymentApi = async (orderId) => {
  return makeRequest(async () => {
    const token = localStorage.getItem("token");
    const url = `${PAYMENT_API_URL}/payment/paymentverify`;

    const response = await axios.post(url, { orderId }, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return response.data;
  });
};